module.exports = __webpack_public_path__ + "static/media/bg-login.20409921.jpg";